export default __webpack_public_path__ + "static/media/af-report-icon.f3d4505a.svg";